import { index } from "./constants";

const selectYourPlanTitle = `Select Your Plan`;

const steps = [
    {
        title: selectYourPlanTitle,
        url: index,
    },
    {
        title: `Create Account`,
        url: index + "/signup",
    },
    {
        title: `Checkout`,
        url: index + "/billing",
    },
    {
        title: `Email Activation`,
        url: index + "/activation",
    },
];

export { steps, selectYourPlanTitle };
